import { AuthenticationService } from '../src/lib'
import ReferrerService  from '../src/lib/AuthenticationService/ReferrerService'
import MC from '../src/lib/MC'

window.MC = MC // Make MC available globally

new ReferrerService().checkRequestOrigin()
// Call the function to start the authentication check
new AuthenticationService().loginSilently().then().catch(console.error)
